import { Injectable } from '@angular/core';
import { interval, Observable, Subject, take } from 'rxjs';

import { demoEvents, demoInitialState } from './demo.data';
import { BaccaratEventType, ChatMessageEvent } from '../models/communication/baccarat-events.model';
import { BaccaratState } from '../models/communication/baccarat-state.model';
import { YEventPayload } from '../models/y-protocol.model';

@Injectable({
    providedIn: 'root'
})
export class DemoService {
    private static readonly eventEmitIntervalMs = 3000;

    private readonly eventMessages = new Subject<YEventPayload<BaccaratEventType>>();

    async getInitData(): Promise<BaccaratState> {
        return Promise.resolve(demoInitialState);
    }

    async getChatMessages(): Promise<ChatMessageEvent[]> {
        return Promise.resolve(demoInitialState.chatMessages ?? []);
    }

    getEventsObservable(): Observable<YEventPayload<BaccaratEventType>> {
        return this.eventMessages.asObservable();
    }

    start(): void {
        interval(DemoService.eventEmitIntervalMs)
            .pipe(take(demoEvents.length))
            .subscribe((i) => {
                this.eventMessages.next({
                    ...demoEvents[i % demoEvents.length],

                    // If you want to show specific phase only, use the following line instead of the above line
                    // ...demoEvents[3 % demoEvents.length],
                    triggered: Date.now()
                });
            });
    }
}
